import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PageRequest, PaginationPage } from 'src/app/common/modules/data-table.module/interfaces';
import { ListFilter } from 'src/app/common/pipes/list-filter.pipe/list-filter.pipe';
import { DoctorPrescription } from 'src/app/entities/prescription.entity/doctor-prescription.entity/doctor-prescription';
import { DoctorPrescriptionService } from 'src/app/services/prescription.service/prescription.service';
import { PrescriptionDto } from '../../Resovler/PrescriptionDto';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-doctor-prescriptions-card',
  templateUrl: './doctor-prescriptions-card.component.html',
  styleUrls: ['./doctor-prescriptions-card.component.css']
})
export class DoctorPrescriptionsCardComponent implements OnInit {

  @Input() currentPage: number = 0;
  @Input() perPage: number = 10;
  doctorPrescriptions: Array<PrescriptionDto> = new Array();
  @Input() pageRequest!: (pageRequest: PageRequest) => Promise<PaginationPage<PrescriptionDto>>;
  @Input() filters: Array<ListFilter> = new Array();
  ngOnInit(): void {
    this.currentPage = 0;

  }
  constructor(private doctorPrescriptionService: DoctorPrescriptionService, private toasterService: ToastrService) { }
 avatarSrc(prescription: PrescriptionDto): string {
    return prescription.patientimage ? `http${environment.API_SSL ? 's' : ''}://${environment.API_HOST_NAME}${environment.PORT ? ':' + environment.PORT : ''}/${environment.STORAGE_ENDPOINT}/${prescription.patientimage}` : 'assets/img/user-avatar.png';
  }
  deletePrescription(index: number): void {
    if (confirm('Êtes-vous sûr(e) de vouloir supprimer cette ordonnance ?'))
      this.doctorPrescriptionService
        .deleteOne(this.doctorPrescriptions[index].id)
        .subscribe(
          (res) => {
            this.toasterService.success('Prescription has deleted');
            this.doctorPrescriptions.splice(index, 1);
          },
          (error) => this.toasterService.error('Enable to delete prescription')
        );
  }

}
